import React, { createContext, useContext, useState, useMemo } from "react";

// Shared navigation visibility state. NavBar and Header are unrelated
// siblings under App.js, so this keeps both mobile and desktop controls synced.
const NavDrawerContext = createContext(null);

export const NavDrawerProvider = ({ children }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  // POS owns a separate top bar and starts with navigation tucked away.
  const [desktopNavVisible, setDesktopNavVisible] = useState(
    () => !window.location.pathname.includes("/PosMainScreen") && !window.location.pathname.startsWith("/edit/invoice")
  );
  // Without memoizing this, every consumer (NavBar, AppBarComp, Fab, ...)
  // re-rendered whenever ANY of them re-rendered for any reason, since a new
  // value object (and thus a new context reference) was created every time
  // NavDrawerProvider itself rendered - not just when these two booleans
  // actually changed.
  const value = useMemo(
    () => ({ mobileNavOpen, setMobileNavOpen, desktopNavVisible, setDesktopNavVisible }),
    [mobileNavOpen, desktopNavVisible]
  );
  return (
    <NavDrawerContext.Provider value={value}>
      {children}
    </NavDrawerContext.Provider>
  );
};

export const useNavDrawer = () => useContext(NavDrawerContext);
